// import "primereact/resources/themes/bootstrap4-light-blue/theme.css"
// import "primereact/resources/themes/bootstrap4-light-purple/theme.css"
// import "primereact/resources/themes/bootstrap4-dark-blue/theme.css"
// import "primereact/resources/themes/bootstrap4-dark-purple/theme.css"
// import "primereact/resources/themes/md-light-indigo/theme.css"               // Label na linha do input
// import "primereact/resources/themes/md-light-deeppurple/theme.css"
// import "primereact/resources/themes/md-dark-indigo/theme.css"
// import "primereact/resources/themes/md-dark-deeppurple/theme.css"
// import "primereact/resources/themes/mdc-light-indigo/theme.css"
// import "primereact/resources/themes/mdc-light-deeppurple/theme.css"
// import "primereact/resources/themes/mdc-dark-indigo/theme.css"
// import "primereact/resources/themes/mdc-dark-deeppurple/theme.css"
// import "primereact/resources/themes/tailwind-light/theme.css"
// import "primereact/resources/themes/fluent-light/theme.css" // Good                      Actual
// import "primereact/resources/themes/lara-light-blue/theme.css"
// import "primereact/resources/themes/lara-light-indigo/theme.css"
// import "primereact/resources/themes/lara-light-purple/theme.css"
// import "primereact/resources/themes/lara-light-teal/theme.css"
// import "primereact/resources/themes/lara-dark-blue/theme.css"
// import "primereact/resources/themes/lara-dark-indigo/theme.css"
// import "primereact/resources/themes/lara-dark-purple/theme.css"
// import "primereact/resources/themes/lara-dark-teal/theme.css"
// import "primereact/resources/themes/soho-light/theme.css"
// import "primereact/resources/themes/soho-dark/theme.css"
// import "primereact/resources/themes/viva-light/theme.css"
// import "primereact/resources/themes/viva-dark/theme.css"
// import "primereact/resources/themes/mira/theme.css"
import "primereact/resources/themes/nano/theme.css" // Very compacted
// import "primereact/resources/themes/saga-blue/theme.css"
// import "primereact/resources/themes/saga-green/theme.css"
// import "primereact/resources/themes/saga-orange/theme.css"
// import "primereact/resources/themes/saga-purple/theme.css"
// import "primereact/resources/themes/vela-blue/theme.css"
// import "primereact/resources/themes/vela-green/theme.css"
// import "primereact/resources/themes/vela-orange/theme.css"
// import "primereact/resources/themes/vela-purple/theme.css"
// import "primereact/resources/themes/arya-blue/theme.css"
// import "primereact/resources/themes/arya-green/theme.css"
// import "primereact/resources/themes/arya-orange/theme.css"
// import "primereact/resources/themes/arya-purple/theme.css"

// import "estilo/theme-fizaqui.css"
// import "primeflex/themes/primeone-light.css"

import * as React from "react"
import { createRoot } from "react-dom/client"
import {
  createBrowserRouter,
  redirect,
  RouterProvider,
} from "react-router-dom"
import Produto from "business/cadastro/produto/produto/Produto"
import ProdutoList from "business/cadastro/produto/produto/ProdutoList"

import Perfil from "business/cadastro/perfil/Perfil"
import PerfilList from "business/cadastro/perfil/PerfilList"

import Config from "business/configuracao/config/Config"
import ConfigList from "business/configuracao/config/ConfigList"

import Empresa from "business/configuracao/empresa/Empresa"
import EmpresaList from "business/configuracao/empresa/EmpresaList"

import PessoaFisica from "business/cadastro/pessoa/pessoaFisica/PessoaFisica"
import PessoaFisicaList from "business/cadastro/pessoa/pessoaFisica/PessoaFisicaList"

import PessoaJuridica from "business/cadastro/pessoa/pessoaJuridica/PessoaJuridica"
import PessoaJuridicaList from "business/cadastro/pessoa/pessoaJuridica/PessoaJuridicaList"

import Usuario from "./business/cadastro/pessoa/usuario/Usuario.jsx"
import UsuarioList from "./business/cadastro/pessoa/usuario/UsuarioList.jsx"

import RamoAtividade from "business/cadastro/pessoa/ramoAtividade/RamoAtividade"
import RamoAtividadeList from "business/cadastro/pessoa/ramoAtividade/RamoAtividadeList"

import Profissao from "business/cadastro/pessoa/profissao/Profissao"
import ProfissaoList from "business/cadastro/pessoa/profissao/ProfissaoList"

import ClassificacaoPessoa from "business/cadastro/pessoa/classificacaoPessoa/ClassificacaoPessoa"
import ClassificacaoPessoaList from "business/cadastro/pessoa/classificacaoPessoa/ClassificacaoPessoaList"

import GrupoPessoa from "business/cadastro/pessoa/grupoPessoa/GrupoPessoa"
import GrupoPessoaList from "business/cadastro/pessoa/grupoPessoa/GrupoPessoaList"

import CategoriaPessoa from "business/cadastro/pessoa/categoriaPessoa/CategoriaPessoa"
import CategoriaPessoaList from "business/cadastro/pessoa/categoriaPessoa/CategoriaPessoaList"

import Hobby from "business/cadastro/pessoa/hobby/Hobby"
import HobbyList from "business/cadastro/pessoa/hobby/HobbyList"

import EstadoCivil from "business/cadastro/pessoa/estadoCivil/EstadoCivil"
import EstadoCivilList from "business/cadastro/pessoa/estadoCivil/EstadoCivilList"

import Sexo from "business/cadastro/pessoa/sexo/Sexo"
import SexoList from "business/cadastro/pessoa/sexo/SexoList"

import Escolaridade from "business/cadastro/pessoa/escolaridade/Escolaridade"
import EscolaridadeList from "business/cadastro/pessoa/escolaridade/EscolaridadeList"

import Unidade from "business/cadastro/produto/unidade/Unidade"
import UnidadeList from "business/cadastro/produto/unidade/UnidadeList"

import Marca from "business/cadastro/produto/marca/Marca"
import MarcaList from "business/cadastro/produto/marca/MarcaList"

import Cor from "business/cadastro/produto/cor/Cor"
import CorList from "business/cadastro/produto/cor/CorList"

import Tamanho from "business/cadastro/produto/tamanho/Tamanho"
import TamanhoList from "business/cadastro/produto/tamanho/TamanhoList"

import EnderecoProduto from "business/cadastro/produto/enderecoProduto/EnderecoProduto"
import EnderecoProdutoList from "business/cadastro/produto/enderecoProduto/EnderecoProdutoList"
import Variavel from "business/cadastro/outros/variavel/Variavel"
import VariavelList from "business/cadastro/outros/variavel/VariavelList"

import Serie from "business/cadastro/fiscal/serie/Serie"
import SerieList from "business/cadastro/fiscal/serie/SerieList"

import Cfop from "business/cadastro/fiscal/cfop/Cfop"
import CfopList from "business/cadastro/fiscal/cfop/CfopList"

import TipoOperacaoFiscal from "business/cadastro/fiscal/tipoOperacaoFiscal/TipoOperacaoFiscal"
import TipoOperacaoFiscalList from "business/cadastro/fiscal/tipoOperacaoFiscal/TipoOperacaoFiscalList"


import OperacaoFiscal from "business/cadastro/fiscal/operacaoFiscal/OperacaoFiscal"
import OperacaoFiscalList from "business/cadastro/fiscal/operacaoFiscal/OperacaoFiscalList"

import IcmsCst from "business/cadastro/fiscal/icmsCst/IcmsCst"
import IcmsCstList from "business/cadastro/fiscal/icmsCst/IcmsCstList"
import Tributo from "business/cadastro/fiscal/tributo/Tributo"
import TributoList from "business/cadastro/fiscal/tributo/TributoList"
import ListaNcm from "business/cadastro/fiscal/listaNcm/ListaNcm"
import ListaNcmList from "business/cadastro/fiscal/listaNcm/ListaNcmList"
import ListaCestNcm from "business/cadastro/fiscal/listaCestNcm/ListaCestNcm"
import ListaCestNcmList from "business/cadastro/fiscal/listaCestNcm/ListaCestNcmList"
import ListaMunicipio from "business/cadastro/fiscal/listaMunicipio/ListaMunicipio"
import ListaMunicipioList from "business/cadastro/fiscal/listaMunicipio/ListaMunicipioList"
import TipoListaNcm from "business/cadastro/fiscal/tipoListaNcm/TipoListaNcm"
import TipoListaNcmList from "business/cadastro/fiscal/tipoListaNcm/TipoListaNcmList"
import TipoListaCestNcm from "business/cadastro/fiscal/tipoListaCestNcm/TipoListaCestNcm"
import TipoListaCestNcmList from "business/cadastro/fiscal/tipoListaCestNcm/TipoListaCestNcmList"
import FinalidadeOperacaoFiscal from "business/cadastro/fiscal/finalidadeOperacaoFiscal/FinalidadeOperacaoFiscal"
import FinalidadeOperacaoFiscalList from "business/cadastro/fiscal/finalidadeOperacaoFiscal/FinalidadeOperacaoFiscalList"
import CbsCst from "business/cadastro/fiscal/cbsCst/CbsCst"
import CbsCstList from "business/cadastro/fiscal/cbsCst/CbsCstList"
import IbsCst from "business/cadastro/fiscal/ibsCst/IbsCst"
import IbsCstList from "business/cadastro/fiscal/ibsCst/IbsCstList"
import IsCst from "business/cadastro/fiscal/isCst/IsCst"
import IsCstList from "business/cadastro/fiscal/isCst/IsCstList"
import PisCst from "business/cadastro/fiscal/pisCst/PisCst"
import PisCstList from "business/cadastro/fiscal/pisCst/PisCstList"
import CofinsCst from "business/cadastro/fiscal/cofinsCst/CofinsCst"
import CofinsCstList from "business/cadastro/fiscal/cofinsCst/CofinsCstList"
import IpiCst from "business/cadastro/fiscal/ipiCst/IpiCst"
import IpiCstList from "business/cadastro/fiscal/ipiCst/IpiCstList"
import ClassificacaoTributaria from "business/cadastro/fiscal/classificacaoTributaria/ClassificacaoTributaria"
import ClassificacaoTributariaList from "business/cadastro/fiscal/classificacaoTributaria/ClassificacaoTributariaList"
import TipoAliquota from "business/cadastro/fiscal/tipoAliquota/TipoAliquota"
import TipoAliquotaList from "business/cadastro/fiscal/tipoAliquota/TipoAliquotaList"
import Cstr from "business/cadastro/fiscal/cstr/Cstr"
import CstrList from "business/cadastro/fiscal/cstr/CstrList"
import ListaUf from "business/cadastro/fiscal/listaUf/ListaUf"
import ListaUfList from "business/cadastro/fiscal/listaUf/ListaUfList"
// #NEW-IMPORT#"

// import "estilo/theme-custom-nano.css"
import "primereact/resources/primereact.min.css"
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'
import 'estilo/App.css'
// import Contact from "./Contact"
import Estoque from "./business/estoque/Estoque"
import Login from "./workarea/Auth/Login"
import AuthLayout from "./AuthLayout"
import Home from "./Home"
import Register from "./workarea/Auth/Register"
import ErrorPage from "./ErrorPage"
import BaseDados from "./workarea/Auth/BaseDados"
import EmpresaAuth from "./workarea/Auth/Empresa"
import AdicionaBaseExtra from "./workarea/Auth/AdicionaBaseExtra"
import RedefinirSenha from "./workarea/Auth/RedefinirSenha"
import Sobre from "./business/ajuda/sobre/Sobre.jsx"
import * as auth from "./infra/localStorage.js"
import ConfirmRegister from "./workarea/Auth/ConfirmRegister"
import ConfirmTenantUserRegister from "./workarea/Auth/ConfirmTenantUserRegister"

import PrimeReact, { addLocale } from 'primereact/api'
// import i18next from "i18next"

// import _i18n from "helper/i18n.js"
import ManualUsuario from "help/ManualUsuario/ManualUsuario.jsx"

addLocale('pt', {
  closeText: 'Fechar',
  prevText: 'Anterior',
  nextText: 'Próximo',
  currentText: 'Começo',
  monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
  monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
  dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
  dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  weekHeader: 'Semana',
  firstDay: 0,
  isRTL: false,
  showMonthAfterYear: false,
  yearSuffix: '',
  timeOnlyTitle: 'Só Horas',
  timeText: 'Tempo',
  hourText: 'Hora',
  minuteText: 'Minuto',
  secondText: 'Segundo',
  ampm: false,
  month: 'Mês',
  week: 'Semana',
  day: 'Dia',
  allDayText: 'Todo o Dia'
})

PrimeReact.ripple = true

const router = createBrowserRouter([
  { path: "login", element: <Login />, loader: redirectIfUser },
  { path: "register", element: <Register />, action: logoutUser },
  { path: "confirmregister", element: <ConfirmRegister />, },
  { path: "confirmtenantuserregister", element: <ConfirmTenantUserRegister />, },
  { path: "base", element: <BaseDados />, },
  { path: "empresa", element: <EmpresaAuth />, },
  { path: "adicionabaseextra", element: <AdicionaBaseExtra />, action: logoutUser },
  { path: "redefinirsenha", element: <RedefinirSenha />, action: logoutUser },
  { path: "logout", action: logoutUser, },
  {
    element: <AuthLayout />,
    children: [
      // { path: "login", element: <Login />, loader: redirectIfUser },
    ],
  },
  {
    path: "/",
    element: <Home />,
    loader: () => {
      const storageData = auth.getData()
      if (!storageData.token) {
        return redirect("/login")
      }
      return false
    },
    children: [
      // {
      //   path: "contact",
      //   element: <Contact />,
      //   errorElement: <ErrorBoundary />,
      //   loader: () => {

      //     const logado = false
      //     if (!logado) {
      //       return redirect("/login")
      //     }
      //     return true
      //   }
      // },
      { path: "cadastro/pessoa/pessoafisicalist", element: <PessoaFisicaList /> },
      { path: "cadastro/pessoa/pessoafisica", element: <PessoaFisica /> },
      { path: "cadastro/pessoa/pessoafisica/:id", element: <PessoaFisica /> },
      { path: "cadastro/pessoa/pessoajuridicalist", element: <PessoaJuridicaList /> },
      { path: "cadastro/pessoa/pessoajuridica", element: <PessoaJuridica /> },
      { path: "cadastro/pessoa/pessoajuridica/:id", element: <PessoaJuridica /> },
      { path: "Cadastro/Pessoa/ramoatividadelist", element: <RamoAtividadeList /> },
      { path: "Cadastro/Pessoa/ramoatividade", element: <RamoAtividade /> },
      { path: "Cadastro/Pessoa/ramoatividade/:id", element: <RamoAtividade /> },
      { path: "cadastro/pessoa/profissaolist", element: <ProfissaoList /> },
      { path: "cadastro/pessoa/profissao", element: <Profissao /> },
      { path: "cadastro/pessoa/profissao/:id", element: <Profissao /> },
      { path: "cadastro/pessoa/classificacaopessoalist", element: <ClassificacaoPessoaList /> },
      { path: "cadastro/pessoa/classificacaopessoa", element: <ClassificacaoPessoa /> },
      { path: "cadastro/pessoa/classificacaopessoa/:id", element: <ClassificacaoPessoa /> },
      { path: "cadastro/pessoa/grupopessoalist", element: <GrupoPessoaList /> },
      { path: "cadastro/pessoa/grupopessoa", element: <GrupoPessoa /> },
      { path: "cadastro/pessoa/grupopessoa/:id", element: <GrupoPessoa /> },
      { path: "cadastro/pessoa/categoriapessoalist", element: <CategoriaPessoaList /> },
      { path: "cadastro/pessoa/categoriapessoa", element: <CategoriaPessoa /> },
      { path: "cadastro/pessoa/categoriapessoa/:id", element: <CategoriaPessoa /> },

      { path: "cadastro/pessoa/hobbylist", element: <HobbyList /> },
      { path: "cadastro/pessoa/hobby", element: <Hobby /> },
      { path: "cadastro/pessoa/hobby/:id", element: <Hobby /> },

      { path: "cadastro/pessoa/estadocivillist", element: <EstadoCivilList /> },
      { path: "cadastro/pessoa/estadocivil", element: <EstadoCivil /> },
      { path: "cadastro/pessoa/estadocivil/:id", element: <EstadoCivil /> },

      { path: "cadastro/pessoa/sexolist", element: <SexoList /> },
      { path: "cadastro/pessoa/sexo", element: <Sexo /> },
      { path: "cadastro/pessoa/sexo/:id", element: <Sexo /> },

      { path: "cadastro/pessoa/escolaridadelist", element: <EscolaridadeList /> },
      { path: "cadastro/pessoa/escolaridade", element: <Escolaridade /> },
      { path: "cadastro/pessoa/escolaridade/:id", element: <Escolaridade /> },

      { path: "estoque", element: <Estoque /> },
      { path: "sobre", element: <Sobre /> },
      { path: "manualusuario", element: <ManualUsuario /> },
      { path: "cadastro/produto/produtolist", element: <ProdutoList /> },
      { path: "cadastro/produto/produto", element: <Produto /> },
      { path: "cadastro/produto/produto/:id", element: <Produto /> },
      { path: "configuracao/config/configlist", element: <ConfigList /> },
      { path: "configuracao/config/config", element: <Config /> },
      { path: "configuracao/config/config/:id", element: <Config /> },
      { path: "configuracao/empresalist", element: <EmpresaList /> },
      { path: "configuracao/empresa", element: <Empresa /> },
      { path: "configuracao/empresa/:id", element: <Empresa /> },
      { path: "cadastro/perfil/perfillist", element: <PerfilList /> },
      { path: "cadastro/perfil/perfil", element: <Perfil /> },
      { path: "cadastro/perfil/perfil/:id", element: <Perfil /> },
      { path: "cadastro/pessoa/usuariolist", element: <UsuarioList /> },
      { path: "cadastro/pessoa/usuario", element: <Usuario /> },
      { path: "cadastro/pessoa/usuario/:id", element: <Usuario /> },

      { path: "cadastro/produto/unidadelist", element: <UnidadeList /> },
      { path: "cadastro/produto/unidade", element: <Unidade /> },
      { path: "cadastro/produto/unidade/:id", element: <Unidade /> },

      { path: "cadastro/produto/marcalist", element: <MarcaList /> },
      { path: "cadastro/produto/marca", element: <Marca /> },
      { path: "cadastro/produto/marca/:id", element: <Marca /> },

      { path: "cadastro/produto/corlist", element: <CorList /> },
      { path: "cadastro/produto/cor", element: <Cor /> },
      { path: "cadastro/produto/cor/:id", element: <Cor /> },

      { path: "cadastro/produto/tamanholist", element: <TamanhoList /> },
      { path: "cadastro/produto/tamanho", element: <Tamanho /> },
      { path: "cadastro/produto/tamanho/:id", element: <Tamanho /> },

      { path: "cadastro/produto/enderecoprodutolist", element: <EnderecoProdutoList /> },
      { path: "cadastro/produto/enderecoproduto", element: <EnderecoProduto /> },
      { path: "cadastro/produto/enderecoproduto/:id", element: <EnderecoProduto /> },
      { path: "cadastro/outros/variavellist", element: <VariavelList /> },
      { path: "cadastro/outros/variavel", element: <Variavel /> },
      { path: "cadastro/outros/variavel/:id", element: <Variavel /> },

      { path: "cadastro/fiscal/serielist", element: <SerieList /> },
      { path: "cadastro/fiscal/serie", element: <Serie /> },
      { path: "cadastro/fiscal/serie/:id", element: <Serie /> },

      { path: "cadastro/fiscal/cfoplist", element: <CfopList /> },
      { path: "cadastro/fiscal/cfop", element: <Cfop /> },
      { path: "cadastro/fiscal/cfop/:id", element: <Cfop /> },


      { path: "cadastro/fiscal/tipooperacao_fiscallist", element: <TipoOperacaoFiscalList /> },
      { path: "cadastro/fiscal/tipooperacao_fiscal", element: <TipoOperacaoFiscal /> },
      { path: "cadastro/fiscal/tipooperacao_fiscal/:id", element: <TipoOperacaoFiscal /> },


      { path: "cadastro/fiscal/operacaofiscallist", element: <OperacaoFiscalList /> },
      { path: "cadastro/fiscal/operacaofiscal", element: <OperacaoFiscal /> },
      { path: "cadastro/fiscal/operacaofiscal/:id", element: <OperacaoFiscal /> },

      { path: "cadastro/fiscal/icmscstlist", element: <IcmsCstList /> },
      { path: "cadastro/fiscal/icmscst", element: <IcmsCst /> },
      { path: "cadastro/fiscal/icmscst/:id", element: <IcmsCst /> },

      { path: "cadastro/fiscal/tributolist", element: <TributoList /> },
      { path: "cadastro/fiscal/tributo", element: <Tributo /> },
      { path: "cadastro/fiscal/tributo/:id", element: <Tributo /> },
      { path: "cadastro/fiscal/listancmlist", element: <ListaNcmList /> },
      { path: "cadastro/fiscal/listancm", element: <ListaNcm /> },
      { path: "cadastro/fiscal/listancm/:id", element: <ListaNcm /> },
      { path: "cadastro/fiscal/listacestncmlist", element: <ListaCestNcmList /> },
      { path: "cadastro/fiscal/listacestncm", element: <ListaCestNcm /> },
      { path: "cadastro/fiscal/listacestncm/:id", element: <ListaCestNcm /> },
      { path: "cadastro/fiscal/listamunicipiolist", element: <ListaMunicipioList /> },
      { path: "cadastro/fiscal/listamunicipio", element: <ListaMunicipio /> },
      { path: "cadastro/fiscal/listamunicipio/:id", element: <ListaMunicipio /> },
      { path: "cadastro/fiscal/tipolistancmlist", element: <TipoListaNcmList /> },
      { path: "cadastro/fiscal/tipolistancm", element: <TipoListaNcm /> },
      { path: "cadastro/fiscal/tipolistancm/:id", element: <TipoListaNcm /> },
      { path: "cadastro/fiscal/tipolistancmlist", element: <TipoListaNcmList /> },
      { path: "cadastro/fiscal/tipolistancm", element: <TipoListaNcm /> },
      { path: "cadastro/fiscal/tipolistancm/:id", element: <TipoListaNcm /> },
      { path: "cadastro/fiscal/tipolistacestncmlist", element: <TipoListaCestNcmList /> },
      { path: "cadastro/fiscal/tipolistacestncm", element: <TipoListaCestNcm /> },
      { path: "cadastro/fiscal/tipolistacestncm/:id", element: <TipoListaCestNcm /> },
      { path: "cadastro/fiscal/finalidadeoperacaofiscallist", element: <FinalidadeOperacaoFiscalList /> },
      { path: "cadastro/fiscal/finalidadeoperacaofiscal", element: <FinalidadeOperacaoFiscal /> },
      { path: "cadastro/fiscal/finalidadeoperacaofiscal/:id", element: <FinalidadeOperacaoFiscal /> },
      { path: "cadastro/fiscal/cbscstlist", element: <CbsCstList /> },
      { path: "cadastro/fiscal/cbscst", element: <CbsCst /> },
      { path: "cadastro/fiscal/cbscst/:id", element: <CbsCst /> },
      { path: "cadastro/fiscal/ibscstlist", element: <IbsCstList /> },
      { path: "cadastro/fiscal/ibscst", element: <IbsCst /> },
      { path: "cadastro/fiscal/ibscst/:id", element: <IbsCst /> },
      { path: "cadastro/fiscal/iscstlist", element: <IsCstList /> },
      { path: "cadastro/fiscal/iscst", element: <IsCst /> },
      { path: "cadastro/fiscal/iscst/:id", element: <IsCst /> },
      { path: "cadastro/fiscal/piscstlist", element: <PisCstList /> },
      { path: "cadastro/fiscal/piscst", element: <PisCst /> },
      { path: "cadastro/fiscal/piscst/:id", element: <PisCst /> },
      { path: "cadastro/fiscal/cofinscstlist", element: <CofinsCstList /> },
      { path: "cadastro/fiscal/cofinscst", element: <CofinsCst /> },
      { path: "cadastro/fiscal/cofinscst/:id", element: <CofinsCst /> },
      { path: "cadastro/fiscal/ipicstlist", element: <IpiCstList /> },
      { path: "cadastro/fiscal/ipicst", element: <IpiCst /> },
      { path: "cadastro/fiscal/ipicst/:id", element: <IpiCst /> },
      { path: "cadastro/fiscal/classificacaotributarialist", element: <ClassificacaoTributariaList /> },
      { path: "cadastro/fiscal/classificacaotributaria", element: <ClassificacaoTributaria /> },
      { path: "cadastro/fiscal/classificacaotributaria/:id", element: <ClassificacaoTributaria /> },
      { path: "cadastro/fiscal/tipoaliquotalist", element: <TipoAliquotaList /> },
      { path: "cadastro/fiscal/tipoaliquota", element: <TipoAliquota /> },
      { path: "cadastro/fiscal/tipoaliquota/:id", element: <TipoAliquota /> },
      { path: "cadastro/fiscal/cstrlist", element: <CstrList /> },
      { path: "cadastro/fiscal/cstr", element: <Cstr /> },
      { path: "cadastro/fiscal/cstr/:id", element: <Cstr /> },
      { path: "cadastro/fiscal/listauflist", element: <ListaUfList /> },
      { path: "cadastro/fiscal/listauf", element: <ListaUf /> },
      { path: "cadastro/fiscal/listauf/:id", element: <ListaUf /> },
      // #NEW-MENU#

      { path: "*", element: <ErrorPage /> },

    ],
  },
])

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
)

function redirectIfUser() {
  return true
}

function logoutUser() {
  return
}

// function ErrorBoundary() {
//   console.log("ERRRRR...")
// }
